import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../@style/BilgiToplumHizmetleri.css';

const BilgiToplumHizmetleri = () => {
  const { isDarkMode } = useTheme();

  const companyData = [
    { label: 'ŞİRKET TÜRÜ', value: 'Anonim Şirket' },
    { label: 'MERSİS', value: '0613-0932-0840-0001' },
    { label: 'TİCARET SİCİL NUMARASI', value: '82392-5' },
    { label: 'TİCARET ÜNVANI', value: 'Masgold Kıymetli Madenler A.Ş.' },
    { label: 'ADRES', value: 'Levazım Mah. Vadi Cad. Zorlu Center No:2 İç Kapı No:568 Beşiktaş-İstanbul' },
    { label: 'ELEKTRONİK TEBLİGAT ADRESİ (UETS)', value: '15057-50463-71673' },
    { label: 'TEL', value: '(212) 501 00 00 - (212) 519 00 53-54' },
    { label: 'FAX', value: 'Yok' },
    { label: 'E-POSTA', value: 'masgold@masgold.com', isLink: true },
    { label: 'SERMAYE MİKTARI', value: '82.500.000 TL' },
    { label: 'ŞİRKET TESCİL TARİHİ', value: '28.04.2017' },
    { label: 'KURULDUĞU ÜLKE', value: 'Türkiye' },
    { label: 'VERGİ DAİRESİ', value: 'Beşiktaş' },
    { label: 'VERGİ NUMARASI', value: '6130932084' },
    { label: 'SEKTÖR', value: 'Kıymetli Madenler' },
    { label: 'YÖNETİM KURULU BAŞKANI', value: 'Rasim Farukoğlu' },
    { label: 'YÖN. KURULU BAŞKAN YARDIMCISI', value: 'Murat Celayir' },
    { label: 'GENEL MÜDÜR', value: 'Usame Serdar Balcı' },
    { label: 'DENETÇİ', value: 'Edit Bağımsız Denetim' },
    {
      label: 'YETKİLİ MÜESSE FASALİYET İZNİ',
      value: '21/08/2023 Borsa İstanbul'
    }
  ];

  return (
    <div className={`bilgi-toplum-page ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className="bilgi-toplum-container">
        <div className="bilgi-toplum-card">
          <h1 className="bilgi-toplum-title">BİLGİ TOPLUMU HİZMETLERİ</h1>
          <table className="bilgi-toplum-table">
            <tbody>
              {companyData.map((row, index) => (
                <tr key={index}>
                  <td className="bilgi-toplum-label">{row.label}</td>
                  <td className="bilgi-toplum-value">
                    {row.isLink ? (
                      <a
                        href={`mailto:${row.value}`}
                        className="bilgi-toplum-link"
                      >
                        {row.value}
                      </a>
                    ) : (
                      row.value
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BilgiToplumHizmetleri;
